module.exports = __webpack_public_path__ + "img/Max Lomuscio.10448c17.jpg";